const CustomXAxisTick = ({ x, y, payload, index, visibleTicksCount }) => {
  const lines = Array.isArray(payload.value) ? payload.value : String(payload.value).split('\n')

  let textAnchor = 'middle'

  if (index === 0) {
    textAnchor = 'start'
  }

  if (index === visibleTicksCount - 1) {
    textAnchor = 'end'
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor={textAnchor} fill="#666" fontSize={12}>
        {lines.map((line, lineIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <tspan key={`${line}-${lineIndex}`} x="0" dy={lineIndex === 0 ? 0 : '1.2em'}>
            {line}
          </tspan>
        ))}
      </text>
    </g>
  )
}

export default CustomXAxisTick
